// SPDX-License-Identifier: AGPL-3.0-or-later

export const CUSTOM_EMOJI_NAME_PATTERN = /<(a)?:([^:>]+):(\d+)>/g;

export type CustomEmojiNamePart =
	| {readonly kind: 'text'; readonly value: string}
	| {readonly kind: 'customEmoji'; readonly animated: boolean; readonly name: string; readonly id: string};

export function parseCustomEmojiNameParts(name: string): Array<CustomEmojiNamePart> {
	const parts: Array<CustomEmojiNamePart> = [];
	let lastIndex = 0;
	CUSTOM_EMOJI_NAME_PATTERN.lastIndex = 0;
	for (const match of name.matchAll(CUSTOM_EMOJI_NAME_PATTERN)) {
		const index = match.index ?? 0;
		if (index > lastIndex) {
			parts.push({kind: 'text', value: name.slice(lastIndex, index)});
		}
		parts.push({
			kind: 'customEmoji',
			animated: match[1] === 'a',
			name: match[2] ?? '',
			id: match[3] ?? '',
		});
		lastIndex = index + match[0].length;
	}
	if (lastIndex < name.length || parts.length === 0) {
		parts.push({kind: 'text', value: name.slice(lastIndex)});
	}
	return parts;
}

export function stripCustomEmojiNameTokens(name: string): string {
	CUSTOM_EMOJI_NAME_PATTERN.lastIndex = 0;
	return name
		.replace(CUSTOM_EMOJI_NAME_PATTERN, '')
		.replace(/-{2,}/g, '-')
		.replace(/\s+/g, ' ')
		.replace(/^[- ]+|[- ]+$/g, '');
}

export function customEmojiNameToPlaintext(name: string): string {
	const stripped = stripCustomEmojiNameTokens(name);
	if (stripped.length > 0) {
		return stripped;
	}
	CUSTOM_EMOJI_NAME_PATTERN.lastIndex = 0;
	return name.replace(CUSTOM_EMOJI_NAME_PATTERN, ':$2:').trim();
}
